export default __webpack_public_path__ + "images/UL.54afff8.png";